export default "__VITE_ASSET__CiqQ5wFR__"